import Vue from "vue";
import notify from "vue-notification";

Vue.use(notify);
